import { ProfileDialog } from '@strata/react-dialog';
import { FullscreenLoading } from '@strata/react-fullscreen-loading';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { useUserProfile } from 'services/APIHooks';

export const UserProfileDialog = ({ isOpen, onCancel }) => {
    const { userProfile, updateUser } = useUserProfile();
    const [isLoading, setIsLoading] = useState(false);
    return (
        <>
            <FullscreenLoading isShowing={isLoading} loadingText="Updating user details." />
            <ProfileDialog
                isOpen={isOpen}
                onSecondaryButtonClick={onCancel}
                useSeparateFirstAndLastName
                userFirstName={userProfile?.firstName}
                userLastName={userProfile?.lastName}
                userFullName={`${userProfile?.firstName ?? ''} ${userProfile?.lastName ?? ''}`}
                userEmailAddress={userProfile?.upn ?? ''}
                onSubmit={(values) => {
                    setIsLoading(true);
                    updateUser({
                        first_name: values.firstName,
                        last_name: values.lastName,
                    });
                    setIsLoading(false);
                    SuccessToast({ message: 'User updated successfully.' });
                }}
            />
        </>
    );
};

UserProfileDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
};
